var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('a-layout-content',{staticClass:"content"},[_c('img',{staticClass:"logo",attrs:{"src":"/loginpic.png","alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }